import { App } from "vue";

import UIIcon from "./elements/UIIcon.vue";
import UIImage from "./elements/UIImage.vue";
import PrimaryBtn from "./elements/PrimaryBtn.vue"

import LetterByLetter from './animations/LetterByLetter.vue'
import LineByLine from './animations/LineByLine.vue'
import LottieAnimation from './animations/LottieAnimation.vue'

const register = (app: App<Element>): void => {
  app.component("ui-icon", UIIcon);
  app.component("ui-image", UIImage);
  app.component("primary-btn", PrimaryBtn);
  
  app.component("lottie-animation", LottieAnimation);
  app.component("letter-by-letter", LetterByLetter);
  app.component("line-by-line", LineByLine);
};

export default { register };